module.exports = __webpack_public_path__ + "img/FleetManager_mehrfarbig_RGB.8ea2a241.svg";